module.exports = __webpack_public_path__ + "img/nina-luna-miller-high-life.420cb24d.png";